module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-Semibold.dcc2827.woff";